import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ClientesContatosService extends BaseService {

  constructor(private http: HttpClient) { super() }

  getClienteContatoById(id: number) {
    return this.http.get(this.UrlService + `ClientesContatos/${id}`)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  getClienteContatos(id: number) {
    return this.http.get(this.UrlService + `ClientesContatos/GetClienteContatos/${id}`)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  salvarContato(model: any) {
    return this.http.post(this.UrlService + 'ClientesContatos', model)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  deleteContato(id: number) {
    return this.http.delete(this.UrlService + `ClientesContatos/${id}`)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }
}